<template>
  <div id="app" class="app">
    <Header />
    <transition name="fade" mode="out-in">
      <router-view class="app-body" />
    </transition>
    <Footer />

    <PortalTarget name="popup-modal" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  beforeMount() {
    if (this.$store.state.questions.questionPaths.length === 0) {
      if (this.$router.currentRoute.path !== "/") {
        this.$router.replace("/");
      }
    }
  },
};
</script>

<style>
@font-face {
  font-family: "Noto Sans Thai";
  src: url(assets/fonts/NotoSansThai/NotoSansThai-Light.ttf) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Noto Sans Thai";
  src: url(assets/fonts/NotoSansThai/NotoSansThai-Regular.ttf)
    format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Noto Sans Thai";
  src: url(assets/fonts/NotoSansThai/NotoSansThai-Medium.ttf) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Noto Sans Thai";
  src: url(assets/fonts/NotoSansThai/NotoSansThai-Bold.ttf) format("truetype");
  font-weight: 700;
  font-style: bold;
  font-display: swap;
}

input {
  font-size: 17px;
}
input:focus,
input:active {
  border-color: #393d43 !important;
  outline: unset;
  outline-offset: unset;
}
input::placeholder {
  font-family: Noto Sans Thai, Arial, Helvetica, sans-serif;
  color: #acb1bf;
}
/* mobile size  */
h1,
h1 * {
  font-size: 34px;
  font-weight: bold;
  margin: 0;
}
h2,
h2 * {
  font-size: 28px;
  font-weight: bold;
  /* line-height: 42px; */
  margin: 0;
}

h3,
h3 * {
  font-size: 23px;
  font-weight: bold;
  /* line-height: 35px; */
  margin: 0;
}
h4,
h4 * {
  font-size: 19px;
  font-weight: bold;
  margin: 0;
}
small,
small * {
  font-size: 12px;
  margin: 0;
}

#app {
  font-family: Noto Sans Thai, Arial, Helvetica, sans-serif;
  font-size: 17px;
  color: #393d43;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

body {
  margin: 0px;
}
.app-body {
  min-height: calc(100vh - 278px);
}
.vue-portal-target {
}

/*size  >480px */
@media only screen and (min-width: 481px) {
  h1,
  h1 * {
    font-size: 40px;
  }
  h2,
  h2 * {
    font-size: 31px;
  }
  h3,
  h3 * {
    font-size: 25px;
  }
  h4,
  h4 * {
    font-size: 20px;
  }
  small,
  small * {
    font-size: 12px;
  }

  .app-body {
    min-height: calc(100vh - 250px);
  }
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  h1,
  h1 * {
    font-size: 48px;
  }
  h2,
  h2 * {
    font-size: 38px;
  }
  h3,
  h3 * {
    font-size: 28px;
    /* line-height: 42px; */
  }
  h4,
  h4 * {
    font-size: 24px;
  }
  small,
  small * {
    font-size: 14px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
}
</style>
